import { ISchema } from '../../@types'
import { mergeDeep } from '@/helpers/utils'
import { IdentsOverrideId } from '@/helpers/identsOverrideIds'

// High CR regular (base original = discounted)
import high_1w_reg from '@/data/products/subscription/prd_qsRUc8c8LpKl'
import high_4w_reg from '@/data/products/subscription/prd_K1E5wBJ4VAmI'
import high_12w_reg from '@/data/products/subscription/prd_ZqA4y0025e6j'

// Low CR regular (ML_PRICE_DISCOUNT override)
import low_1w_reg from '@/data/products/subscription/prd_Ehunvmipw4zl'
import low_4w_reg from '@/data/products/subscription/prd_Q1aRLGmyYjfz'
import low_12w_reg from '@/data/products/subscription/prd_w9Xrf1I9oxmi'

// chair-tai-chi-m base paywall has no abort-fallback (fallback = null), original = discounted.
// Base idents = High CR; ML discount segment swaps to Low CR via identsOverride.
export default (schema: ISchema): ISchema =>
	mergeDeep(
		{ ...schema },
		{
			config: {
				products: [
					{
						idents: {
							original: high_1w_reg.ident,
							discounted: high_1w_reg.ident,
							fallback: null,
						},
						identsOverride: [
							{
								id: IdentsOverrideId.ML_PRICE_DISCOUNT,
								original: low_1w_reg.ident,
								discounted: low_1w_reg.ident,
								fallback: null,
							},
						],
					},
					{
						idents: {
							original: high_4w_reg.ident,
							discounted: high_4w_reg.ident,
							fallback: null,
						},
						identsOverride: [
							{
								id: IdentsOverrideId.ML_PRICE_DISCOUNT,
								original: low_4w_reg.ident,
								discounted: low_4w_reg.ident,
								fallback: null,
							},
						],
						default: true,
					},
					{
						idents: {
							original: high_12w_reg.ident,
							discounted: high_12w_reg.ident,
							fallback: null,
						},
						identsOverride: [
							{
								id: IdentsOverrideId.ML_PRICE_DISCOUNT,
								original: low_12w_reg.ident,
								discounted: low_12w_reg.ident,
								fallback: null,
							},
						],
					},
				],
			},
		},
	)
